export function createRedirectLink(link: string) {
    const { pathname, search } = new URL(link)

    const qrcId = pathname.replace('/', '')

    return `https://halvacard.ru/lk/qr/${qrcId}${search}`
}
